
import React from 'react';
import DebugInterviewSubmissionFormContainer from './form/DebugInterviewSubmissionFormContainer';

interface DebugInterviewSubmissionFormProps {
  requestLink: string;
  isPageLoading?: boolean;
}

const DebugInterviewSubmissionForm: React.FC<DebugInterviewSubmissionFormProps> = ({ 
  requestLink, 
  isPageLoading = false 
}) => {
  if (!requestLink) {
    return <div>No request link provided</div>;
  }

  if (isPageLoading) {
    return <div>Page loading...</div>;
  }

  return (
    <DebugInterviewSubmissionFormContainer 
      requestLink={requestLink}
      isPageLoading={isPageLoading}
    />
  );
};

export default DebugInterviewSubmissionForm;
